import { Component, inject } from '@angular/core';
import { Tab, TabList, Tabs } from 'primeng/tabs';
import { Router, RouterLink, RouterOutlet } from '@angular/router';
import { Card } from 'primeng/card';
import {
  AuthService,
  USER_ROLE_OWNER,
  USER_ROLE_MANAGER,
} from '../../services/AuthService';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-hr-index',
  standalone: true,
  imports: [Tabs, TabList, Tab, RouterLink, RouterOutlet, Card, TranslocoPipe],
  template: `
    <p-card [style]="{ maxWidth: '100vw' }">
      <p-tabs [value]="activeTab()">
        <p-tablist>
          <p-tab
            value="/hr/employees"
            routerLink="/hr/employees"
            class="flex flex-col gap-2 lg:flex-row items-center">
            <i class="pi pi-user"></i>
            <span>{{ 'Employees' | transloco }}</span>
          </p-tab>
          <p-tab
            value="/hr/positions"
            routerLink="/hr/positions"
            class="flex flex-col gap-2 lg:flex-row items-center">
            <i class="pi pi-briefcase"></i>
            <span>{{ 'Positions' | transloco }}</span>
          </p-tab>
        </p-tablist>
      </p-tabs>
      <router-outlet></router-outlet>
    </p-card>
  `,
})
export class HrIndex {
  public router = inject(Router);
  public auth = inject(AuthService);
  protected readonly USER_ROLE_OWNER = USER_ROLE_OWNER;
  protected readonly USER_ROLE_MANAGER = USER_ROLE_MANAGER;

  activeTab(): string {
    return this.router.url.startsWith('/hr/positions') ? '/hr/positions' : '/hr/employees';
  }
}
